import type { TeamLLMModelGroupDTO } from "@/contexts/teams-provider";
import type { TeamLLMDTO } from "@shaarp/common";

/**
 * The providers in the order the model picker and the team settings show
 * them. Display only: the order `auto` falls back in is decided API-side.
 */
const PROVIDER_GROUPS: readonly Omit<TeamLLMModelGroupDTO, "models">[] = [
  { id: "anthropic", name: "Anthropic" },
  { id: "openai", name: "OpenAI" },
  { id: "mistral", name: "Mistral AI" },
];

/**
 * Sorts the team's models under their provider, providers in display order.
 * A model of a provider not listed here is left out.
 */
export function groupTeamLLMsByProvider(
  teamLLMList: TeamLLMDTO[]
): TeamLLMModelGroupDTO[] {
  return PROVIDER_GROUPS.map((group) => ({
    ...group,
    models: teamLLMList.filter((llm) => llm.groupId === group.id),
  }));
}
